import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { milestones } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the network resource
export const [actions, reducer, resourceSagas] = resourceReducer('milestones');

// Create the sagas for this entity
function* readMilestones() {
  yield takeEvery(actions.indexRequestBegin, function*() {
    try {
      const result = yield call(milestones.get);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess(normalized));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error })
    }
  });
}

export const sagas = [readMilestones, ...resourceSagas];
